import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { SEARCH_FIELD_NAMES, STEEL_MAKER_NAME, STEEL_MILLS_AICHI, STEEL_MILLS_KOBE, STEEL_MILLS_JFE, STEEL_MILLS_NSC } from '../../../constants';
import type { SelectOptionIndexed } from '../../../types/common';

const steelMillsNsc: SelectOptionIndexed[] = Object.values(STEEL_MILLS_NSC).map((mill) => ({
  index: mill.index,
  label: mill.nameJapanese,
  value: mill.nameJapanese,
}));
const steelMillsAichi: SelectOptionIndexed[] = Object.values(STEEL_MILLS_AICHI).map((mill) => ({
  index: mill.index,
  label: mill.nameJapanese,
  value: mill.nameJapanese,
}));
const steelMillsKobe: SelectOptionIndexed[] = Object.values(STEEL_MILLS_KOBE).map((mill) => ({
  index: mill.index,
  label: mill.nameJapanese,
  value: mill.nameJapanese,
}));
const steelMillsJfe: SelectOptionIndexed[] = Object.values(STEEL_MILLS_JFE).map((mill) => ({
  index: mill.index,
  label: mill.nameJapanese,
  value: mill.nameJapanese,
}));


interface SelectMillJaProps {
  selectedSteelMakerJa: string;
  value: string;
  disabled?: boolean;
  onChangeMill: (fieldName: string, value: string) => void;
}

const SelectMillJa = ({ selectedSteelMakerJa, value, disabled = false, onChangeMill }: SelectMillJaProps): JSX.Element => {
  // console.log(name, value);
  const steelMills = [...steelMillsNsc, ...steelMillsAichi, ...steelMillsKobe, ...steelMillsJfe].sort((a, b) => a.index - b.index);
  const [selectedOption, setSelectedOption] = useState<SelectOptionIndexed | null>(null);
  const [options, setOptions] = useState<SelectOptionIndexed[]>(steelMills);
  // 堺(阪神)や大分(光鋼管)のように半角カッコが入っているミルはダブルクォーテーションで囲ってあるため
  // 表示時にはダブルクォーテーションを外す
  const getOptionLabel = (option: SelectOptionIndexed): string => option.label.replace(/"/g, '');

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (selectedSteelMakerJa === STEEL_MAKER_NAME.NIPPONSTEEL.JA) {
      setOptions(() => steelMillsNsc);
    } else if (selectedSteelMakerJa === STEEL_MAKER_NAME.AICHISTEEL.JA) {
      setOptions(() => steelMillsAichi);
    } else if (selectedSteelMakerJa === STEEL_MAKER_NAME.KOBESTEEL.JA) {
      setOptions(() => steelMillsKobe);
     } else if (selectedSteelMakerJa === STEEL_MAKER_NAME.JFESTEEL.JA) {
      setOptions(() => steelMillsJfe);
    } else {
      setOptions(() => steelMills);
    }
  }, [selectedSteelMakerJa]);

  useEffect(() => {
    if (value !== '') {
      const newSelectedOption: SelectOptionIndexed | undefined = options.find((option) => option.value === value);
      // console.log(newSelectedOption);
      if (newSelectedOption !== undefined) {
        setSelectedOption(newSelectedOption);
      }
    } else {
      setSelectedOption(null);
      onChangeMill(SEARCH_FIELD_NAMES.MILL_JA, '');
    }
  }, [value]);

  // EVENT HANDLER
  // ================================================================================

  const handleOptionChange = (option: SelectOptionIndexed | null): void => {
    // console.log(option);
    setSelectedOption(option);
    const newValue: string = option.value;
    onChangeMill(SEARCH_FIELD_NAMES.MILL_JA, newValue);
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Select
        id={SEARCH_FIELD_NAMES.MILL_JA}
        name={SEARCH_FIELD_NAMES.MILL_JA}
        className="react-select-container"
        classNamePrefix="react-select"
        value={selectedOption}
        options={options}
        getOptionLabel={getOptionLabel}
        onChange={handleOptionChange}
        placeholder="選択して下さい"
        isDisabled={disabled}
      />
    </>
  );
};

export default SelectMillJa;
